import { render, staticRenderFns } from "./PrescriptionPopup.vue?vue&type=template&id=2550f8b8&scoped=true"
import script from "./PrescriptionPopup.vue?vue&type=script&lang=js"
export * from "./PrescriptionPopup.vue?vue&type=script&lang=js"
import style0 from "./PrescriptionPopup.vue?vue&type=style&index=0&id=2550f8b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2550f8b8",
  null
  
)

export default component.exports